/**
 * Component shows summary information of each product in the cart
 *
 * @attr {String} [order-code] - Products are already ordered
 * @attr {Boolean} [read-only] - Simplified version
 * @attr {String} [css-class] - Additional css class
 *
 * @attr {String} [max-quantity-error-label] - Quantity selector max error text
 * @attr {String} [min-quantity-error-label] - Quantity selector min error text
 * @attr {String} [product-code-label] - product code (ref) label
 * @attr {String} [quantity-label] - product quantity-label
 *
 * Parameters - comes from redux store:
 * @param {Array} entries - The entries in the cart
 *
 * Example of usage:
 * <e2-order-product-summary-grid
 *      order-code="1234"
 * ></e2-order-product-summary-grid>
 *
 * Order code is used on: payment, order-confirmation, order detail pages
 */

import connect from '@elab/core/store/connect';
import { actions, selectors } from '@elab/core/store/order';
import { selectors as configSelectors } from '@elab/core/store/config';
import { actions as uiActions } from '@elab/core/store/ui';
import { actions as globalActions } from '@elab/core/store/global';

import { ProductSummaryGrid } from '../cart/ProductSummaryGrid';

const mapStateToProps = state => {
    if (configSelectors.getProductDifferentiationRequiredStatus(state)) {
        return {
            readOnly: true,
            entries: selectors.getEntriesWithoutGiftAndFreeSamples(state),
            giftProducts: selectors.getEntriesWithGiftAndFreeSample(state),
        };
    }
    return {
        readOnly: true,
        entries: selectors.getEntries(state),
    };
};

const mapDispatchToEvents = (dispatch, ctx) => ({
    'load-order': () => dispatch(actions.loadOrder(ctx.orderCode, true, false, ctx.offlineOrder)),
    'open-dialog': ({ detail }) => dispatch(uiActions.openDialog(detail)),
    'set-egift-card-entry-number': ({ detail }) =>
        dispatch(actions.setEGiftCardEntryNumber(detail)),
    'goto-pdp': ({ detail }) => dispatch(globalActions.goto(detail.url)),
});

export default () =>
    customElements.define(
        'e2-order-product-summary-grid',
        connect(mapStateToProps, mapDispatchToEvents)(ProductSummaryGrid),
    );
